import React from "react";

import { Grid } from "@material-ui/core";
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import DoneIcon from '@mui/icons-material/Done';
import TextField from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import * as Constants from "../../../../consts/Constants.js";

import service from '../../../../plas/services/shifter/service';
import alerter from "../../../alerts/alerter"

export default function ShiftForm({
  initialShift,
  eventId,
  shiftId,
  onCancel,
  onSave,
  fullWidth
}) {

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FFFFFF',
        darker: '#FFFFFF',
      }
    },
  });

  const [shift, setShift] = React.useState(initialShift ? initialShift : null);
  const [loading, setLoading] = React.useState(!initialShift);

  const [date, setDate] = React.useState(initialShift ? initialShift.date : null);
  const [capacity, setCapacity] = React.useState(initialShift ? initialShift.capacity : 0);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (!initialShift)
      loadShift()
    else {
        setDate(initialShift.date);
        setCapacity(initialShift.capacity);
        setLoading(false);
      }
  }, []);

  const loadShift = () => {
    setLoading(true);
    service.api.shifts.get(eventId, shiftId, (response) => {
      if (response.error != null) {
        alerter.showError(response.error);
        if (onCancel)
          onCancel()
      } else {
        setShift(response.result);
        setDate(response.result.date);
        setCapacity(response.result.capacity);
        setLoading(false);
      }
    });
  }

  const saveHandler = () => {
    if (shift.id) { 
      update()
    } else {
      create();
    }
  }

  const create = () => {
    setSaving(true)
    service.api.shifts.create(shift, (response) => {
      if (response.result != null) {
        if (onSave)
          onSave(response.result);
      } else {
        alerter.showError(response.error);
      }
      setSaving(false)
    });
  }

  const update = () => {
    setSaving(true)
    service.api.shifts.update(shift, (response) => {
      if (response.result != null) {
        if (onSave)
          onSave(response.result);
      } else {
        alerter.showError(response.error);
      }
      setSaving(false)
    });
  }

  const onChangeDate = (e) => {
    let value = e.target.value;
    if (!value){
      shift.date = null;
      setDate(null);
    } else {
      let aux = new Date(value);
      let time = aux.getTime();
      shift.date = time;
      setDate(time);
    }
  }

  const onChangeCapacity = (e) => {
    let value = parseInt(e.target.value);
    if (value >= shift.occupancy) {
      shift.capacity = value;
      setCapacity(value);
    }
  }

  const ColoredLine = ({ color }) => (
      <hr
          style={{
              color: color,
              backgroundColor: color,
              marginTop: 6,
              marginBottom: 16,
              height: 2
          }}
      />
  );


  return(
    <Grid container>
      <Grid item xs={12} style={{ textAlign: "center"}}>
        { loading ? (
          <CircularProgress style={{color:Constants.COLOR_PRIMARY}} color="inherit" />
        ):(
          <Grid container spacing={2}>
            <Grid item xs={false} md={ fullWidth ? false : 2} />
              <Grid item xs={12} md={ fullWidth ? 12 : 8} >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                <p style={{ fontSize: '28px', textAlign: 'left'}}>
                  Datos del turno
                </p>
                <ColoredLine color="gray"/>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          id="date"
                          label="Fecha del turno"
                          name="date"
                          type="datetime-local"
                          defaultValue={date ? new Date(date).toISOString().slice(0, 16) : null}
                          onChange={onChangeDate}
                          disabled={(saving || shift.id)}
                          InputLabelProps={{
                            shrink: true
                          }}
                          fullWidth/>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          required
                          variant="outlined"
                          id="capacity"
                          disabled={saving}
                          label="Capacidad de aforo"
                          name="capacity"
                          type="number"
                          value={capacity}
                          onChange={onChangeCapacity}
                          fullWidth
                          placeholder="Capacidad de aforo"/>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
                <Grid item xs={12}>
                  <ColoredLine color="gray"/>
                  <Grid container spacing={2}>
                    <Grid item xs={true}/>
                    <Grid item>
                      { onCancel && (
                        <ThemeProvider theme={theme}>
                          <Button 
                            disabled={saving} 
                            startIcon={<CancelIcon/>} 
                            variant="contained" 
                            onClick={() => onCancel()}>
                            Cancelar
                          </Button>
                        </ThemeProvider>
                      )}
                    </Grid>
                    <Grid item>
                      { onSave && (
                        <LoadingButton
                          disabled={!shift.isValid()}
                          loadingPosition="start"
                          startIcon={<DoneIcon />}
                          loading={saving}
                          variant="contained"
                          onClick={saveHandler}>
                          <b>{ shift.id ? "Guardar" : "Crear" }</b>
                        </LoadingButton>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={false} md={ fullWidth ? false : 2} />
          </Grid>
        )}
      </Grid>
    </Grid>
  )

}
